<template>
	<div class="page" style="position: relative;overflow-y: auto;">
		<div class="titleView">
			<el-row>
				<el-col :span="18">
					<div style="font-size: 16px;font-weight: bold;padding:0 10px;">资产调拨</div>
				</el-col>
				<el-col :span="5" >
					<el-button size="small" type="warning" plain @click="$router.back()">返回</el-button>
				</el-col>
			</el-row>
		</div>

		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="no" label="编号" column-key="tab3key1">
				<template slot-scope="scope">
					{{scope.row.assetsCode}}
				</template>
			</el-table-column>
			<el-table-column label="名称" column-key="tab3key2">
				<template slot-scope="scope">
					{{scope.row.assetsName}}
				</template>
			</el-table-column>
			<el-table-column label="规格" column-key="tab3key3">
				<template slot-scope="scope">
					<span>{{scope.row.skuName}}</span>
				</template>
			</el-table-column>
			<el-table-column label="可调拨库存" column-key="tab3key4">
				<template slot-scope="scope">
					<span>{{scope.row.stockInfo.wait}}</span>
				</template>
			</el-table-column>

			<el-table-column label="调拨数量" column-key="tab3key5">
				<template slot-scope="scope">
					<el-input placeholder="请输入调拨数量" v-model="scope.row.count" maxlength="30" resize="none" size="small"/>
				</template>
			</el-table-column>

			<el-table-column label="操作" column-key="tab3key7">
				<template slot-scope="scope">
					<el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
				
				</template>
			</el-table-column>
		</el-table>
		<div class="titleView">
			<el-row style="padding: 10px;">
				<el-col :span="8">
					<div>调拨原因:
					 <el-input style="width: 150px;"  type="textarea" v-model="reson"></el-input>
					</div>
				</el-col>
				<el-col :span="7" style="margin-right:10px;">
					<div>调拨门店:
						<el-select v-model="storeId" placeholder="请选择" class="titleSelect" size="small">
							<el-option v-for="item in storeList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id" />
						</el-select>
					</div>
				</el-col>
				<el-col :span="5">
					<el-button size="small" type="warning" @click="add">添加资产</el-button>
				</el-col>
				<el-col :span="3">
					<el-button size="small" type="warning" @click="submit">提交</el-button>
				</el-col>
			</el-row>
		</div>
		<div v-if="drawerSeeApply_state">
			<drawerSeeApply  @submit="submit_drawerSelectProduct"></drawerSeeApply>
		</div>
	</div>
</template>

<script>
	import drawerSeeApply from "./drawer_seeApply.vue"
	export default {
		components: {
			drawerSeeApply
		},
		data() {
			return {
				tableData: [],
				storeList: [],
				storeId: '',
				reson:'',
				drawerSeeApply_state:false,
				shopInfo:{
					id:'',
					name:''
				}
			}
		},
		mounted() {
			if(this.$store.state.shopId){
				this.shopInfo.id=this.$store.state.shopId;
				this.shopInfo.name=this.$public.getShopNameById(this.$store.state.shopId);
			}
			this.getStoreData()
		},
		methods: {
			//提交
			submit() {
				if(this.tableData.length == 0){
					this.$message({
						message: '请添加资产',
						type: 'error'
					});
					return
				}
				if(this.count){
					this.$message({
						message: '请输入调拨数量',
						type: 'error'
					});
					return
				}
				if(this.$public.isNull(this.reson)){
					this.$message({
						message: '请输入调拨原因',
						type: 'error'
					});
					return
				}
				if(this.$public.isNull(this.storeId&&this.storeId)){
					this.$message({
						message: '请选择调拨门店',
						type: 'error'
					});
					return
				}
				if(this.shopInfo.id==this.storeId){
					this.$message({
						message: '请重新选择调拨门店',
						type: 'error'
					});
					return
				}
				let list = []
				for(let i=0;i<this.tableData.length;i++){
					list.push({
						"assetsCode": this.tableData[i].assetsCode.toString(),
						"assetsName":  this.tableData[i].assetsName,
						"skuName":  this.tableData[i].skuName,
						"count": this.tableData[i].count*1,
						"assetsType": this.tableData[i].assetsType,
					})
				}
			let params = {
				'shopInfo': this.shopInfo,
				'remark':this.reson,
				'assetsList':list,
				 "receiveInfo": {
				    "id":this.storeId,
				    "name":this.$types.get_physicalShops_type(this.storeId),
				  },
			}
			console.log('params111', params)
			this.$http.post(process.env.VUE_APP_zichan + '/api/AssetsShop/transfer', params).then(res => {
					console.log('调拨111', res)
				if (res.code == 0) {
					// this.StaffList = res.data.data;
					this.$message({
						type: 'success',
						message: '分配成功!'
					});
					this.tableData=[];
					this.reson='';
					this.storeId='';
				}
			})
			},
			submit_drawerSelectProduct(obj) {
				if(obj.type==="success"){
					for(let i=0;i<this.tableData.length;i++){
						if (this.tableData[i].id == obj.data.id) {
							this.$message({
								message: '该资产已添加',
								type: 'warning'
							})
							return
						}
					}
					this.$set(obj.data,'count','')
					this.tableData.push(obj.data)
					console.log(this.tableData)
				}else if(obj.type==='close'){
					this.drawerSelectProduct_state = false
				}
			},
			//删除
			del(obj){
				for(let i=0;i<this.tableData.length;i++){
					if (this.tableData[i].id == obj.id) {
						this.tableData.splice(i,1);
						this.$message({
							message: '删除成功',
							type: 'warning'
						})
						return
					}
				}
			},
			// 添加
			add(){
				this.drawerSeeApply_state=true;
			},
			//获取门店
			getStoreData() {
				let params = {
					companyId: '5e9412e0b2bfbc030160bdd5'
				}
				this.$http.get(process.env.VUE_APP_Url2 + 'api/CompanyInfo/shoplist', params).then(res => {
					if (res.code == 0) {
						// console.log('门店', res)
						this.storeList = res.data
					}
				})
			},
		}

	}
</script>

<style lang="scss" scoped>
	.page {
		height: 100%;

		// 重复头部
		.titleView {
			// width: 98%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}
	}
</style>
